import { render, staticRenderFns } from "./EditAlternativeContractPage.vue?vue&type=template&id=8a5bbb5e&"
import script from "./EditAlternativeContractPage.vue?vue&type=script&lang=js&"
export * from "./EditAlternativeContractPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports